import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { tNegocio } from "./shared";

const t = (key) => tNegocio(`pages.publicidad.plans.status.${key}`);

const TONES = {
  paid: { color: "#047857", background: "rgba(4,120,87,0.12)" },
  activating: { color: "#b45309", background: "rgba(180,83,9,0.12)" },
  review: { color: "#1d4ed8", background: "rgba(29,78,216,0.12)" },
  binance_pending: { color: "#a16207", background: "rgba(240,185,11,0.18)" },
  rejected: { color: "#b91c1c", background: "rgba(185,28,28,0.12)" },
  expired: { color: "#6b7280", background: "rgba(107,114,128,0.14)" },
  cancelled: { color: "#6b7280", background: "rgba(107,114,128,0.14)" },
  unpaid: { color: "#6b7280", background: "rgba(107,114,128,0.10)" },
};

/** Estado combinado: estado de la orden en Publicidad IA + estado del pago en la plataforma. */
export const paymentStateOf = (row) => {
  if (row.estado && row.estado !== "pendiente") return row.estado === "cancelada" ? "cancelled" : "paid";
  if (row.paymentStatus === "paid") return "activating";
  return row.paymentStatus || "unpaid";
};

export function PaymentStatusChip({ row }) {
  const state = paymentStateOf(row);
  const tone = TONES[state] || TONES.unpaid;
  const chip = (
    <span style={{ ...tone, padding: "2px 9px", borderRadius: 99, fontSize: 12, fontWeight: 700, whiteSpace: "nowrap" }}>
      {t(state)}
    </span>
  );
  const tip = state === "rejected" ? row.reviewMessage : state === "activating" ? row.partnerError : null;
  return tip ? <Tooltip title={tip} arrow>{chip}</Tooltip> : chip;
}
